export function filterCategories(categories, filter) {
    if (categories && filter.length > 0) {
        return categories
            .slice()
            .map(category => {
                const categoryNodes =
                    category.categoryNodes
                        ?.slice()
                        .filter(node =>
                            node.title
                                .toLowerCase()
                                .includes(filter.toLowerCase())
                        ) || [];
                return {
                    ...category,
                    categoryNodes
                };
            })
            .filter(category => category.categoryNodes.length > 0);
    }
    return categories;
}
